import React from 'react';
import { Box } from '@mui/material';

const PageLayout = ({ children, leftNav = null }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: leftNav ? 'auto 1fr' : '1fr',
        gridTemplateRows: '1fr',
        bgcolor: 'background.default',
      }}
    >
      {leftNav && (
        <Box sx={{
          borderRight: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          width: '200px'
        }}>
          {leftNav}
        </Box>
      )}
      <Box sx={{
        overflowX: 'auto',
        overflowY: 'visible',
        p: 3,
      }}>
        {children}
      </Box>
    </Box>
  );
};

export default PageLayout;
